import React, { useState, useEffect } from 'react';
import {Modal, Button, Table, Input, Select, Space, Row, Col, message, Spin} from 'antd';
import UIFetchService from "../Service/UIFetchService";
import {DeleteOutlined, PlusOutlined} from "@ant-design/icons";
import {isEmpty, isNotEmpty} from "../Service/Utils";

function TraceParamEdit(props) {

    const [channelLevels, setChannelLevels] = useState([])
    const [channels, setChannels] = useState([])
    const [channelOptions, setChannelOptions] = useState([])
    const [channelLv1, setChannelLv1] = useState(null)
    const [channelLv2, setChannelLv2] = useState(null)
    const [channelId, setChannelId] = useState(null)
    const [paramKey, setParamKey] = useState(null)
    const [saving, setSaving] = useState(false)

    const [params, setParams] = useState([])
    const [team, setTeam] = useState(null)

    useEffect(() => {
        fetchChannelLevels()
        fetchChannels()
    }, [])

    useEffect(() => {
        if (props.editingParam != null) {

            setChannelId(props.editingParam.channelId)
            setTeam(props.editingParam.team)
            setParamKey(props.editingParam.paramKey)

            const labels = JSON.parse(props.editingParam.labels)
            if (!("承接渠道" in labels)) {
                labels['承接渠道'] = null
            }
            const labelList = Object.keys(labels).map(l => {
                return {
                    label: l,
                    value: labels[l]
                }
            }).sort((label1, label2) => {
                const orders = ['承接渠道', '商品名称', '老师', '资源位']
                const order1 = orders.indexOf(label1.label)
                if (order1 < 0) {
                    return 1
                }
                const order2 = orders.indexOf(label2.label)
                if (order2 < 0) {
                    return -1
                }
                return orders.indexOf(label1.label) - orders.indexOf(label2.label)
            })

            setParams([
                {
                    id: props.editingParam.id,
                    team: props.editingParam.team,
                    paramId: props.editingParam.paramId,
                    remark: props.editingParam.remark,
                    labelList: labelList
                }
            ])
        }
        if (props.isCreate) {
            createParam()
        }
    }, [props.editingParam])

    useEffect(() => {
        if (channelId != null && team != null && channels != null && channels.length > 0) {
            const chn = channels.find(c => c.channelId === channelId && c.team === team)
            if (chn != null) {
                setChannelLv1(chn.channelLv1)
                setChannelLv2(chn.channelLv2)
            }
        }
    }, [channelId, channels, team])

    useEffect(() => {
        if (channels != null && channels.length > 0) {
            setChannelOptions(
                channels.filter(c =>
                    (channelLv1 == null || c.channelLv1 === channelLv1) &&
                    (channelLv2 == null || c.channelLv2 === channelLv2)
                )
            )
        }
    }, [channelLv1, channelLv2, channels])

    const createParam = () => {
        let initLabels = {
            承接渠道: '',
            商品名称: '',
            老师: '',
            资源位: ''
        }

        const newParam = {
            paramId: '',
            remark: '',
            labelList: Object.keys(initLabels).map(l => {
                return {
                    label: l,
                    value: ''
                }
            })
        }
        setParams([...params, newParam])
    }

    const handleCancel = () => {
        props.onCancel()
    }

    const handleOk = () => {
        saveParams()
    }

    const fetchChannelLevels = () => {
        UIFetchService.get('/api/v1/trace/channel/levels')
            .then(res => {
                if (res != null) {
                    setChannelLevels(res)
                }
            })
    }

    const fetchChannels = () => {
        UIFetchService.get('/api/v1/trace/channels')
            .then(res => {
                if (res != null) {
                    setChannels(res)
                }
            })
    }

    const _getParamIdPrefix = () => {
        return channelId
    }

    const _mapParamLabels = (labelList) => {
        // 转成固定参数的存储格式
        let labels = {}
        if (labelList != null && labelList.length > 0) {
            for (const label of labelList) {
                if (isEmpty(label.label)) {
                    message.error('标签信息Key不能为空')
                    return null
                }

                if (labels[label.label] != null) {
                    message.error('标签信息Key不能重复')
                    return null
                }

                labels[label.label] = label.value
            }
        }

        return labels
    }

    const saveParams = () => {
        if (channelLv1 == null || channelLv1 === 0) {
            message.error("请选择一级渠道")
            return
        }
        if (channelLv1 == null || channelLv1 === 0) {
            message.error("请选择二级渠道")
            return
        }
        if (isEmpty(channelId)) {
            message.error("请选择来源渠道")
            return
        }
        if (isEmpty(paramKey)) {
            message.error("请选择Key")
            return
        }
        if (params == null || params.length === 0) {
            message.error("请至少包含一条追踪参数信息")
            return
        }
        for (let param of params) {
            if (isEmpty(param.paramId)) {
                message.error("请输入追踪参数标识")
                return
            }
            if (isEmpty(param.remark)) {
                message.error("请输入追踪参数描述")
                return
            }
        }

        const paramList = params.map(p => {
            return {
                ...p, labels: JSON.stringify(_mapParamLabels(p.labelList)), paramId: props.isCreate ? _getParamIdPrefix() + p.paramId : p.paramId
            }
        })
        const body = {
            channelId: channelId,
            paramKey: paramKey,
            team: team,
            params: paramList
        }

        setSaving(true)
        // 新建追踪参数
        if (props.isCreate) {
            UIFetchService.post('/api/v1/trace/params', body)
                .then((result) => {
                    if (result == null) {
                        message.error("新增追踪参数失败，请检查是否有相同的参数标识")
                        return
                    }

                    message.success("新增追踪参数成功")
                    setSaving()
                    props.onOk()
                })

        } else {
            UIFetchService.put('/api/v1/trace/params', body)
                .then((result) => {
                    if (result == null) {
                        message.error("编辑追踪参数失败")
                        return
                    }
                    message.success("编辑追踪参数成功")
                    props.onOk()
                })
        }
    }

    return <>
        <Modal
            title={props.title}
            open={props.visible}
            width={1500}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <Spin spinning={saving}>
                    <Button key="back" onClick={handleCancel}>
                        取消
                    </Button>
                    <Button key="submit" type="primary" onClick={handleOk}>
                        确定
                    </Button>
                </Spin>
            ]}
        >
            <Row style={{ marginBottom: 15}}>
                <Col>
                    <span style={{color: '#1890ff'}}>1. 选择基础信息</span>
                </Col>
            </Row >
            <Row style={{ marginBottom: 10}}>
                <Col flex='100px' style={{ alignSelf: 'center', textAlign: 'center' }}>
                    <span style={{color: 'red'}}>* &nbsp;</span>一级渠道
                </Col>
                <Col flex='200px'>
                    <Select
                        disabled={!props.isCreate}
                        style={{width: '100%'}}
                        allowClear
                        value={channelLv1}
                        onChange={value => {
                            setChannelLv1(value)
                            setChannelLv2(null)
                            setChannelId(null)
                        }
                    }
                    >
                        {channelLevels.map(cl => <Select.Option key={cl.id} value={cl.id}> {cl.name} </Select.Option>)}
                    </Select>
                </Col>
                <Col flex='100px' style={{ alignSelf: 'center', textAlign: 'center' }}>
                    <span style={{color: 'red'}}>* &nbsp;</span>二级渠道
                </Col>
                <Col flex='200px'>
                    <Select
                        disabled={!props.isCreate}
                        style={{width: '100%'}}
                        allowClear
                        value={channelLv2}
                        onChange={value => {
                            setChannelLv2(value)
                            setChannelId(null)
                        }
                    }
                    >
                        {channelLv1 != null && channelLevels.find(cl => cl.id === channelLv1) != null ?
                            channelLevels.find(cl => cl.id === channelLv1).subChannels.map(cl => <Select.Option key={cl.id} value={cl.id}> {cl.name} </Select.Option>)
                            :
                            []
                        }
                    </Select>
                </Col>
            </Row>
            <Row style={{marginBottom: 10}}>
                <Col flex='100px' style={{ alignSelf: 'center', textAlign: 'center' }}>
                    <span style={{color: 'red'}}>* &nbsp;</span>渠道名称
                </Col>
                <Col flex='500px'>
                    <Select style={{width: '100%'}}
                            disabled={!props.isCreate}
                            allowClear
                            showSearch
                            optionFilterProp="children"
                            value={channelId == null ? null : channelId + '|' + team}
                            onChange={value => {
                                const arr = value.split('|')
                                setChannelId(arr[0])
                                setTeam(arr[1])
                            }}
                    >
                        {channelOptions.map(c => <Select.Option key={c.channelId + '|' + c.team} value={c.channelId + '|' + c.team}>
                            {`${c.channelName} (${c.channelId}  ${c.team})`}
                        </Select.Option>)}
                    </Select>
                </Col>
            </Row>
            <Row style={{marginBottom: 10}}>
                <Col flex='100px' style={{ alignSelf: 'center', textAlign: 'center' }}>
                    <span style={{color: 'red'}}>* &nbsp;</span>Key
                </Col>
                <Col flex='200px'>
                    <Select
                        disabled={!props.isCreate}
                        value={paramKey}
                        style={{ width: '100%' }}
                        onChange={value => {
                           setParamKey(value)
                        }}
                    >
                        <Select.Option value="trace">trace</Select.Option>
                        <Select.Option value="buy_from">buy_from</Select.Option>
                        <Select.Option value="ADTAG">ADTAG</Select.Option>
                        <Select.Option value="channel">channel</Select.Option>
                        <Select.Option value="utm_source">utm_source</Select.Option>
                    </Select>
                </Col>
                <Col flex='20px'>
                </Col>
                <Col flex='auto' style={{ alignSelf: 'center' }}>
                    <span style={{color: '#6c6c6c', fontSize: 12}}>说明：如需在<a target='_blank' href='https://mallbackend.baicizhan.com/orders'>老商城后台</a>查看订单来源，Key 务必选择 trace</span>
                </Col>
            </Row>
            <Row style={{ marginTop: 15, marginBottom: 15}}>
                <Col>
                    <span style={{color: '#1890ff'}}>2. 创建追踪参数</span>
                </Col>
            </Row>
            {params.map((p, index) => <>
                <Row style={{ marginBottom: 10}}>
                    <Col flex="100px" style={{ textAlign: 'center', paddingTop: 5 }}>
                        <span style={{color: '#ff4d4f'}}>*&nbsp;</span><span>追踪参数标识</span>
                    </Col>
                    <Col flex="250px">
                        {props.isCreate ?
                            <Input addonBefore={_getParamIdPrefix()}
                                   value={p.paramId}
                                   style={{ width: '100%' }}
                                   onChange={({ target }) => {
                                       setParams([
                                           ...params.slice(0, index),
                                           {...p, paramId: target.value},
                                           ...params.slice(index + 1)
                                       ])
                                   }} />
                            :
                            <Input value={p.paramId} disabled />
                        }
                    </Col>
                    <Col flex="100px" style={{ textAlign: 'center', paddingTop: 5 }}>
                        <span style={{color: '#ff4d4f'}}>*&nbsp;</span><span>追踪参数描述</span>
                    </Col>
                    <Col flex="250px">
                        <Input value={p.remark} onChange={(e) => setParams([
                            ...params.slice(0, index),
                            {...p, remark: e.target.value},
                            ...params.slice(index + 1)
                        ]) } />
                    </Col>
                    <Col flex="80px" style={{ textAlign: 'center', paddingTop: 5 }}>
                        标签信息
                    </Col>
                    <Col flex='auto'>
                        <div style={{border: '1px solid #eee', padding: 10 }}>
                        {
                            p.labelList.map((label, lblIdx) => <Row style={{marginBottom: 10}}>
                                <Col flex="100px">
                                    {
                                        ["承接渠道", "商品名称", "老师", "资源位"].indexOf(label.label) >= 0 ? <span> {label.label} </span> :
                                            <Input value={label.label}  onChange={(e) => {
                                                const l = e.target.value
                                                setParams([
                                                    ...params.slice(0, index),
                                                    {...p, labelList: [
                                                            ...p.labelList.slice(0, lblIdx),
                                                            {...label, label: l},
                                                            ...p.labelList.slice(lblIdx + 1)
                                                        ]
                                                    },
                                                    ...params.slice(index + 1)
                                                ])
                                            }
                                            }/>
                                    }
                                </Col>
                                <Col><span>&nbsp;:&nbsp;</span></Col>
                                <Col flex="200px">
                                    {label.label === "承接渠道" ?
                                        <Select
                                            showSearch
                                            value={label.value}
                                            style={{ width: '100%' }}
                                            filterOption={(input, option) => option.children.includes(input)}
                                            onChange={async value => {
                                                setParams([
                                                    ...params.slice(0, index),
                                                    {...p, labelList: [
                                                            ...p.labelList.slice(0, lblIdx),
                                                            {...label, value: value},
                                                            ...p.labelList.slice(lblIdx + 1)
                                                        ]
                                                    },
                                                    ...params.slice(index + 1)
                                                ])
                                            }}
                                        >
                                            { channels
                                                .map(ci => <Select.Option key={ci.channelId} value={ci.channelId}>{ci.channelName}</Select.Option>) }
                                        </Select>
                                        :
                                        <Input value={label.value} max={100} min={0} onChange={(e) => {
                                            const v = e.target.value
                                            setParams([
                                                ...params.slice(0, index),
                                                {...p, labelList: [
                                                        ...p.labelList.slice(0, lblIdx),
                                                        {...label, value: v},
                                                        ...p.labelList.slice(lblIdx + 1)
                                                    ]
                                                },
                                                ...params.slice(index + 1)
                                            ])
                                          }
                                        }/>
                                    }
                                </Col>
                                <Col flex="4px"></Col>
                                <Col style={{ alignSelf: 'center' }}>
                                    { ["承接渠道", "商品名称", "老师", "资源位"].indexOf(label.label) >= 0 ? null :
                                        <Button
                                            size="small"
                                            danger
                                            type="link"
                                            icon={<DeleteOutlined />}
                                            onClick={() => setParams([
                                                    ...params.slice(0, index),
                                                    {...p, labelList: [
                                                            ...p.labelList.slice(0, lblIdx),
                                                            ...p.labelList.slice(lblIdx + 1)
                                                        ]
                                                    },
                                                    ...params.slice(index + 1)
                                                ])
                                            }
                                        />
                                    }
                                </Col>
                            </Row>)
                        }
                            <Row >
                                <Col>
                                    <Button
                                        type="link"
                                        size="small"
                                        onClick={() =>
                                            setParams([
                                                ...params.slice(0, index),
                                                {...p, labelList: [
                                                        ...p.labelList,
                                                        {label: "", value: ""}
                                                    ]
                                                },
                                                ...params.slice(index + 1)
                                            ])
                                        }

                                    ><PlusOutlined /> 添加自定义标签
                                    </Button>
                                </Col>
                            </Row>

                        </div>
                    </Col>
                    {props.isCreate ?
                        <Col style={{alignSelf: 'center'}}>
                            <Button
                                danger
                                type="link"
                                icon={<DeleteOutlined />}
                                onClick={() => setParams([
                                    ...params.slice(0, index),
                                    ...params.slice(index + 1)
                                ])
                                }
                            />
                        </Col> : null
                    }
                </Row>
            </>
            )}
            { props.isCreate &&
                <Button type='link' icon={<PlusOutlined />} onClick={createParam}>增加一个追踪参数</Button>
            }
        </Modal>
    </>
}

export default TraceParamEdit
